import { ChevronRightSmall } from 'blaze-ui/icons'
import { Chip } from './Chip'
import Styles from './ChipMenu.module.scss'
import { MenuTrigger } from 'components/MenuTrigger/MenuTrigger'
import { Menu } from 'components/Menu/Menu'
import { SelectableItem } from 'components/Menu/MenuItem'
import { Section } from '@react-stately/collections'
import { ItemElement } from '@react-types/shared'
import { Key } from 'react'
import { capitalize } from 'lodash'

interface Props {
  type: string
  label: string
  selectedOption: string
  options: string[]
  onChange: (option: string) => void
  isDisabled?: boolean
}

export const ChipMenu = ({ type, label, selectedOption, options, onChange, isDisabled }: Props) => {
  const handleAction = (key: Key) => {
    const option = key as string
    onChange(option)
  }

  return (
    <MenuTrigger popoverClassName={Styles.popover}>
      <Chip size="md" variant="grey" onPress={() => {}} isDisabled={isDisabled}>
        <div className={Styles.container}>
          <div className={Styles.info}>
            <span className={Styles.type}>{type}</span>
            <span className={Styles.label}>{label}</span>
          </div>
          <ChevronRightSmall size={16} color="var(--dark-80)" />
        </div>
      </Chip>
      <Menu
        onAction={handleAction}
        aria-label={type}
        showCheckmark
        selectionMode="single"
        selectedKeys={[selectedOption as Key]}
        itemClassName={Styles.optionMenuItem}
      >
        <Section>
          {
            options.map((option) => (
              <SelectableItem type="item" key={option} textValue={capitalize(option)}>
                <span className={Styles.option}>{capitalize(option)}</span>
              </SelectableItem>
            )) as ItemElement<HTMLElement>[]
          }
        </Section>
      </Menu>
    </MenuTrigger>
  )
}
